import type { AssetCondition, BuildingType } from '@aikoa/common'
import { type TFunction } from '@aikoa/i18n/react'

export function getBuildingTypeLabel({
  buildingType,
  t,
  short,
}: {
  buildingType: BuildingType
  t: TFunction<'property', undefined>
  short?: boolean
}): string {
  if (!buildingType) {
    return ''
  }

  const result = t(($) => {
    if (short) {
      return $.buildingTypesShort[buildingType as keyof typeof $.buildingTypesShort]
    }

    return $.buildingTypes[buildingType as keyof typeof $.buildingTypes]
  })

  return result || buildingType
}

export function getConditionLabel(
  condition: AssetCondition,
  t: TFunction<'property', undefined>
): string {
  if (!condition) {
    return ''
  }

  const result = t(($) => $.conditions[condition as keyof typeof $.conditions])

  return result || condition
}
